export default {
  Code: "",
  Description: "",
  TaxRate: 0,
  Active: true,
  UserModified: localStorage.getItem("UserName"),
};
